import React, { useState, useEffect } from "react";
import "../../components/style/global.css";
import DialogBox from "../util/DialogBox";
import UserInfos from "./UserInfos";
import LoadingBox, { closeLoadingBox } from "../util/LoadingBox";
import { useTranslation } from "react-i18next";
import { roadmakerApi } from "../../api/roadmakerApi";

const UserProfile = ({
  userData,
  userName,
  setUserName,
  avatar,
  setAvatar,
}) => {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);
  const [email, setEmail] = useState(userData.email);
  const [userInformations, setUserInformations] = useState(null);

  /**
   * Récupère les données de l'utilisateur
   */
  const fetchUserData = async () => {
    LoadingBox({
      text: t("pleaseWait"),
      icon: "info",
    });
    try {
      const user = await roadmakerApi.users.get(userData._id);
      closeLoadingBox();
      setEmail(user.email);
      setAvatar(user.avatar);
      setUserInformations(user);
      return user;
    } catch (error) {
      console.log(error);
      closeLoadingBox();
    }
  };

  useEffect(() => {
    fetchUserData()
      .catch((err) => {
        console.log(err);
        DialogBox({
          title: t("error"),
          text: t("errorLoadingDatas"),
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  }, []);

  /**
   *
   * @param {event} e
   * Permet de valider les modification de l'utilisateur en cours
   */
  const handleValider = async (e) => {
    e.preventDefault();
    try {
      const updatedUser = await roadmakerApi.users.update(userData._id, {
        name: userName,
        avatar: avatar,
      });
      setUserInformations(updatedUser);
      DialogBox({
        text: t("updateInformations"),
        icon: "success",
        confirmButtonText: "OK",
      });
      setIsEditing(false);
    } catch (error) {
      console.log(error);
    }
  };
  /**
   * Permet d'annuler les modifications de l'utilisateur en cours
   */
  const handleAnnuler = () => {
    setIsEditing(false);
    setUserName(userInformations.name);
    setEmail(userInformations.email);
    setAvatar(userInformations.avatar);
  };

  /**
   *
   * @param {event} e
   * Permet de changer l'avatar de l'utilisateur
   */
  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    const maxSize = 5 * 1024 * 1024;

    if (file.size > maxSize) {
      DialogBox({
        text: t("largeFile"),
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setAvatar(reader.result);
    };
    reader.readAsDataURL(file);
  };
  return (
    <div className="container justify-content-center  p-4">
      <div className="d-flex justify-content-center">
        <div className="col-md-8  text-center">
          <div className="user-component">
            <div className="row justify-content-center">
              <div className="">
                <UserInfos
                  isEditing={isEditing}
                  setIsEditing={setIsEditing}
                  setUserName={setUserName}
                  userName={userName}
                  email={email}
                  setAvatar={setAvatar}
                  avatar={avatar}
                  handleAnnuler={handleAnnuler}
                  handleValider={handleValider}
                  handleAvatarChange={handleAvatarChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
